// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7620) return "static/chunks/7620-24df2122632ef07c.js";
	if (chunkId === 9748) return "static/chunks/9748-2722a1ee00c71459.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1691":"43a97ff2b0ab03a6","8757":"2c81048e17f47a09"}[chunkId] + ".js";
};